module.exports = __webpack_public_path__ + "static/newchapter-6881ea56fcebcb28730e09d2f76d2300.jpeg";